export default "__VITE_ASSET__c45aafae__"